<template>
  <div class="hello">
    <modal
      name="unstakePanel"
      classes="msg-modal"
      width="400px"
      :adaptive="true"
    >
      <h3>{{ $t("i18nView.unstakeToRex") }}</h3>
      <p class="common-tips">{{ $t("i18nView.unstakeToRexTips") }}</p>

      <p>
        {{ $t("i18nView.stakedAccount") }}: {{ unstakedAccount }}
        <span v-if="currentAccount === unstakedAccount"
          >({{ $t("i18nView.you") }})</span
        >
      </p>
      <table>
        <tr>
          <th>CPU</th>
          <th>NET</th>
          <th></th>
        </tr>
        <tr>
          <td>{{ unstakedCpuLimit }}</td>
          <td>{{ unstakedNetLimit }}</td>
        </tr>
        <tr>
          <td>
            <input type="text" placeholder="CPU" v-model="unstakedCpu" />
          </td>
          <td>
            <input type="text" placeholder="NET" v-model="unstakedNet" />
          </td>
          <td>
            <button class="button danger" @click="doUnstake">
              {{ $t("i18nView.unstake") }}
            </button>
          </td>
        </tr>
      </table>
    </modal>

    <modal
      name="resFundPanel"
      classes="msg-modal"
      width="400px"
      :adative="true"
    >
      <div v-if="rentDetail">
        <h3 :class="rentDetailType === 'fund' ? 'buy' : 'sell'">
          {{
            rentDetailType === "fund"
              ? $t("i18nView.fundText")
              : $t("i18nView.unfundText")
          }}
        </h3>

        <p>
          <label>{{ $t("i18nView.resType") }}：</label>
          {{ rentDetail.type }}
        </p>

        <p>
          <label>{{ $t("i18nView.resReceiver") }}:</label>
          {{ rentDetail.receiver }}
        </p>
        <p>
          <label>{{ $t("i18nView.dueTime") }}</label>
          {{ rentDetail.expiration | utcTime }}
        </p>
        <p>
          <label>{{ $t("i18nView.payment") }}:</label>
          {{ rentDetail.payment | number }}
        </p>

        <p>
          <label>{{ $t("i18nView.resourceFund") }}:</label>
          {{ rentDetail.balance | number }}
        </p>

        <!-- <p>
          <label>REX {{$t('i18nView.fund')}}:</label>
          {{rexFundBalance}}
        </p>-->

        <p>
          <input
            type="text"
            :placeholder="$t('i18nView.amount') + ' ' + sysSymbol"
            v-model="resFundAmount"
          />
          <button
            :class="
              rentDetailType === 'fund' ? 'button success' : 'button danger'
            "
            @click="doResFund(rentDetailType, rentDetail)"
          >
            {{
              rentDetailType === "fund"
                ? $t("i18nView.fundText")
                : $t("i18nView.unfundText")
            }}
          </button>
        </p>
      </div>
    </modal>

    <modal name="maturities" classes="msg-modal" width="400px" :adaptive="true">
      <h3>{{ $t("i18nView.rexMaturity") }}</h3>
      <table v-if="!!rexMaturities.length">
        <tr>
          <th>{{ $t("i18nView.maturityTime") }}</th>
          <th>{{ $t("i18nView.amount") }}</th>
        </tr>
        <tr v-for="(matureItem, index) in rexMaturities">
          <td v-if="matureItem.isStaked">{{ $t("i18nView.rexSavings") }}</td>
          <td v-else>{{ matureItem.key | utcTime }}</td>
          <td>
            {{ parseFloat(matureItem.value / 10000).toFixed(4) + " REX" }}
          </td>
        </tr>
      </table>
    </modal>

    <modal
      name="rexSavings"
      classes="msg-modal"
      width="400px"
      height="400px"
      :adaptive="true"
    >
      <h3>{{ $t("i18nView.rexSavings") }}</h3>
      <p>{{ $t("i18nView.savingTips") }}</p>
      <hr />
      <h4>
        REX {{ $t("i18nView.stakeable") }}:
        {{
          parseFloat(parseFloat(rexBalance) - parseFloat(rexStaked)).toFixed(
            4
          ) + " REX"
        }}
      </h4>
      <input
        type="text"
        :placeholder="$t('i18nView.amount') + ' REX'"
        v-model="mvToSavingAmount"
      />
      <button @click="stakeREX" class="clickable success button">
        {{ $t("i18nView.stakeRex") }}
      </button>
      <hr />
      <h4>REX {{ $t("i18nView.staked") }}: {{ rexStaked }}</h4>
      <input
        type="text"
        :placeholder="$t('i18nView.amount') + ' REX'"
        v-model="mvFrSavingAmount"
      />
      <button @click="unstakeREX" class="clickable danger button">
        {{ $t("i18nView.unstakeRex") }}
      </button>
    </modal>
    <!-- 卖出排队中  -->
    <modal
      name="realRexQueue"
      classes="msg-modal"
      width="400px"
      height="400px"
      :adaptive="true"
    >
      <h3>{{ $t("i18nView.sellRexOrder") }}</h3>

      <div class="table-wrap" style="max-height: 290px; overflow: auto">
        <table v-if="realQueue.length">
          <tr>
            <th></th>
            <th>{{ $t("i18nView.account") }}</th>
            <th>{{ $t("i18nView.amount") }}</th>
            <th>{{ $t("i18nView.applyTime") }}</th>
          </tr>
          <tbody>
            <tr v-for="(item, index) in realQueue">
              <td>{{ index + 1 }}</td>
              <td>{{ item.owner }}</td>
              <td>
                {{
                  parseFloat(
                    (parseFloat(item.rex_requested) *
                      parseFloat(eosTotalLentable)) /
                      parseFloat(rexTotal)
                  ).toFixed(4)
                }}
              </td>
              <td>{{ item.createTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <button @click="refreshQueueList">{{ $t("i18nView.refresh") }}</button>
      </p>
    </modal>

    <!-- 租借订单 -->
    <modal
      name="loanOrders"
      classes="msg-modal"
      width="400px"
      height="400px"
      :adaptive="true"
    >
      <h3>{{ $t("i18nView.loanStatus") }}</h3>

      <div
        class="table-wrap"
        style="
          max-height: 290px;
          overflow: auto;
          -webkit-overflow-scrolling: touch;
        "
      >
        <table class="loan-table" v-if="loanTotalList.length">
          <tr>
            <th></th>
            <th>{{ $t("i18nView.account") }}</th>
            <th>{{ $t("i18nView.amount") }}</th>
            <th>{{ $t("i18nView.expiredTime") }}</th>
          </tr>
          <tbody>
            <tr v-for="(item, index) in loanTotalList">
              <td>{{ index + 1 }}</td>
              <td>{{ item.from }}</td>
              <td>{{ parseFloat(item.total_staked).toFixed(4) }}</td>
              <td :class="item.expried ? 'expired' : ''">
                {{ item.expireTime }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        <button @click="refreshLoanList">{{ $t("i18nView.refresh") }}</button>
        <button v-if="hasExpiredLoan" @click="cleanLoanList()">
          {{ $t("i18nView.helpCleanOrder") }}
        </button>
      </p>
    </modal>

    <modal
      @before-open="beforeOpen"
      height="auto"
      classes="msg-modal"
      width="400px"
      :adaptive="true"
      name="message"
      >{{ msg }}</modal
    >

    <div class="row">
      <div class="col-2">
        <div class="card">
          <h2>
            <i class="iconfont icon-account"></i>
            <span>{{ $t("i18nView.personalInfo") }}</span>
          </h2>
          <p>
            {{ $t("i18nView.account") }}:
            <span v-if="!!currentAccount">
              {{ currentAccount }}
              <a class="clickable" @click="logout">
                <!-- {{$t('i18nView.logout')}} -->
                <i class="pc-only iconfont icon-logout"></i>
              </a>
            </span>
            <span v-else>
              <button class="clickable success button" @click="login">
                {{ $t("i18nView.login") }}
              </button>
            </span>
          </p>
          <p>REX {{ $t("i18nView.balance") }}: {{ rexBalance }}</p>

          <p v-if="rexBalance && eosTotalLentable && rexTotal">
            {{ $t("i18nView.rexValue") }}:
            {{
              parseFloat(
                parseFloat(rexBalance) *
                  parseFloat(
                    parseFloat(eosTotalLentable) / parseFloat(rexTotal)
                  )
              ).toFixed(4) +
              " " +
              sysSymbol
            }}
          </p>

          <p v-if="tip1 === '1'" class="tips">
            *{{ $t("i18nView.rexFundTips") }} {{ sysSymbol }}
            {{ $t("i18nView.rexFundTips1") }} {{ sysSymbol }}
            {{ $t("i18nView.rexFundTips2") }}
            <span @click="ikonw('tip1')" class="close">
              {{ $t("i18nView.iknow") }}
              <!-- <i class="iconfont icon-close"></i> -->
            </span>
          </p>

          <div class="row">
            <div class="col-6">
              <p>
                {{ sysSymbol }} {{ $t("i18nView.balance") }}:
                <br />
                <span class="clickable" @click="syncEosBalance()">{{
                  eosBalance
                }}</span>
              </p>
              <p>
                <input
                  type="number"
                  v-model="fundAmount"
                  :placeholder="$t('i18nView.amount') + ' ' + sysSymbol"
                />
              </p>
              <p>
                <button class="button success" @click="transferToRexFund">
                  {{ $t("i18nView.deposit") }}
                </button>
              </p>
            </div>
            <div class="col-6">
              <p>
                REX {{ $t("i18nView.fund") }}:
                <br />
                <span class="clickable" @click="syncFundAmount()">{{
                  rexFundBalance
                }}</span>
              </p>
              <p>
                <input
                  type="number"
                  v-model="fundWithdrawAmount"
                  :placeholder="$t('i18nView.amount') + ' ' + sysSymbol"
                />
              </p>
              <p>
                <button class="button danger" @click="withdrawFromRexFund">
                  {{ $t("i18nView.withdraw") }}
                </button>
              </p>
            </div>
          </div>
        </div>

        <div class="card overview pc-only">
          <h2>{{ $t("i18nView.overview") }}</h2>
          <p>
            <label>{{ $t("i18nView.totalRex") }}:</label>
            {{ rexTotal }}
          </p>
          <p>
            <label>{{ sysSymbol }} {{ $t("i18nView.totalEos") }}:</label>
            {{ eosTotalLentable }}
          </p>
          <p>
            <label>{{ sysSymbol }} {{ $t("i18nView.lent") }}:</label>
            {{ eosTotalLent }}
          </p>
          <p>
            <label>{{ sysSymbol }} {{ $t("i18nView.lendable") }}:</label>
            {{ eosTotalUnlent }}
          </p>
          <p>
            <label>{{ $t("i18nView.totalRentNumber") }}:</label>
            {{ loanNum }}
          </p>
          <p>
            <label>{{ $t("i18nView.rentPrice") }}:</label>
            {{ resPrice }} {{ sysSymbol }} * 30 {{ $t("i18nView.day") }} /
            {{ sysSymbol }}
          </p>
          <p>
            <label>{{ $t("i18nView.lentPercent") }}:</label>
            {{
              parseFloat(
                (parseInt(eosTotalLent) / parseInt(eosTotalLentable)) * 100
              ).toFixed(2) + "%"
            }}
          </p>

          <!-- <p>
            <label>{{$t('i18nView.rentCost')}}:</label>
            {{parseFloat(parseFloat(eosTotalRent) - 20000).toFixed(4) + ' ' + sysSymbol}}
          </p>-->
          <p>
            <label for>{{ $t("i18nView.ramIncome") }}:</label>
            {{ ramIncome }}
          </p>
          <p>
            <label for>{{ $t("i18nView.bidnameIncome") }}:</label>
            {{ bidnameIncome }}
          </p>
          <p>
            <label>{{ $t("i18nView.apr") }}:</label>
            {{ apr }}
          </p>
        </div>
      </div>

      <div class="tab-wrap mobile-only">
        <div
          @click="active('rex-tab')"
          :class="tabName === 'rex-tab' ? 'active tab' : 'tab'"
        >
          {{ $t("i18nView.rexTrading") }}
        </div>
        <div
          @click="active('res-tab')"
          :class="tabName === 'res-tab' ? 'active tab' : 'tab'"
        >
          {{ $t("i18nView.resBorrow") }}
        </div>
      </div>

      <div
        :class="
          tabName === 'rex-tab' ? 'active col-4 rex-panel' : 'col-4 rex-panel'
        "
      >
        <div class="card">
          <h2>
            {{ $t("i18nView.rexPriceTrend") }}
            <em>
              {{
                parseFloat(
                  parseFloat(eosTotalLentable) / parseFloat(rexTotal)
                ).toFixed(10)
              }}
              {{ sysSymbol }} / REX
            </em>
            <!-- <span class="range-select"></span> -->
          </h2>

          <!-- <div id="rex-chart"></div> -->
        </div>

        <div class="card">
          <h2>
            {{ $t("i18nView.rexTrading") }}
            <em v-if="rexQueue !== 0" @click="viewRealQueue">
              <b>
                {{ $t("i18nView.currentRexQueue") }}:
                <!-- {{$t('i18nView.queueing')}}  -->
                {{ validRexQueue }}
                <!-- <span
                  class="total-order"
                >/ {{rexQueue}}</span>-->
              </b>
            </em>
          </h2>

          <div class="row">
            <div class="col-6 buy-rex">
              <h3>{{ $t("i18nView.buyRex") }}</h3>
              <p class="w-90">
                REX {{ $t("i18nView.fund") }}:
                <br class="mobile-only" />
                <span @click="syncFund" class="clickable pc-fr">{{
                  rexFundBalance
                }}</span>
              </p>
              <p>
                <input
                  class="input-eos"
                  type="number"
                  v-model="rexAmount"
                  :placeholder="$t('i18nView.amount') + ' ' + sysSymbol"
                />
                <label class="fr-label"
                  >≈
                  {{
                    parseFloat(
                      (rexAmount * parseFloat(rexTotal)) /
                        parseFloat(eosTotalLentable)
                    ).toFixed(4)
                  }}
                  REX</label
                >
                <button class="button success" @click="buyRex">
                  {{ $t("i18nView.buyRex") }}
                </button>
              </p>
              <p v-if="isVoted === null"></p>
              <p class="common-tips" v-else-if="!isVoted">
                {{ $t("i18nView.voteTips") }} {{ defaultProxy }}
              </p>
            </div>
            <div class="col-6 sell-rex">
              <h3>{{ $t("i18nView.sellRex") }}</h3>
              <p class="w-90">
                {{ $t("i18nView.availableRex") }}:
                <br class="mobile-only" />
                <span @click="syncRex" class="clickable pc-fr"
                  >{{ maturedRex }} REX</span
                >
              </p>

              <p>
                <input
                  class="input-eos"
                  type="number"
                  v-model="rexSellAmount"
                  :placeholder="$t('i18nView.amount') + ' REX'"
                />
                <label class="fr-label"
                  >≈
                  {{
                    parseFloat(
                      (rexSellAmount * parseFloat(eosTotalLentable)) /
                        parseFloat(rexTotal)
                    ).toFixed(4)
                  }}
                  {{ sysSymbol }}</label
                >
                <button class="button danger" @click="sellRex">
                  {{ $t("i18nView.sellRex") }}
                </button>
              </p>
              <p>REX {{ $t("i18nView.balance") }}: {{ rexBalance }}</p>

              <p v-if="myQueueRex !== 0">
                {{ $t("i18nView.myRexInQueue") }}: {{ myQueueRex }}
                <br />
                <span v-if="myRexQueueStatus === 1">
                  {{ $t("i18nView.myQueueIndex") }}: {{ myRexQueueIndex }}
                  <br />
                  <button class="mini" @click="cancelRexQueue">
                    {{ $t("i18nView.cancelRexQueue") }}
                  </button>
                </span>
                <button
                  class="mini"
                  @click="updateRexStatus"
                  v-else-if="myRexQueueStatus === 0"
                >
                  {{ $t("i18nView.updateRexStatus") }}
                </button>
              </p>

              <h4
                @click="manageRexSavings()"
                class="pop-modal"
                v-if="rexBalance"
              >
                {{ $t("i18nView.manageRexSavings") }}
              </h4>

              <h4
                @click="viewRestRex()"
                class="pop-modal"
                v-if="!!rexMaturities.length"
              >
                {{ $t("i18nView.viewRestRex") }}
              </h4>
            </div>
          </div>
        </div>

        <div class="card">
          <h2>{{ $t("i18nView.stakeList") }}</h2>
          <p>{{ $t("i18nView.unstakeTips") }}</p>
          <!-- <h2>取消抵押资源并转换为REX</h2> -->
          <div class="stake-table-wrap" v-if="!!stakedList.length">
            <table class="stake-table">
              <tr>
                <th>{{ $t("i18nView.stakedAccount") }}</th>
                <th>CPU</th>
                <th>NET</th>
                <th>{{ $t("i18nView.unstakeToRex") }}</th>
              </tr>
              <tr v-for="staked in stakedList">
                <td>
                  {{ staked.to }}
                  <span v-if="currentAccount === staked.to"
                    >({{ $t("i18nView.you") }})</span
                  >
                </td>
                <td>
                  {{ staked.cpu_weight }}
                  <!-- <button
                  @click="stakedToRex(staked.to, '0.0000 EOS', staked.cpu_weight)"
                  >转为REX</button>-->
                </td>
                <td>
                  {{ staked.net_weight }}
                  <!-- <button
                  @click="stakedToRex(staked.to, staked.net_weight, '0.0000 EOS')"
                  >转为REX</button>-->
                </td>
                <td>
                  <button
                    class="mini"
                    @click="
                      stakedToRex(
                        staked.to,
                        staked.net_weight,
                        staked.cpu_weight
                      )
                    "
                  >
                    {{ $t("i18nView.unstake") }}
                    <!-- <i class="iconfont icon-switch"></i> -->
                  </button>
                </td>
              </tr>
            </table>
            <ul
              v-if="pageNo !== 1 || (pageNo === 1 && stakedList.length === 10)"
              class="pagination"
            >
              <li v-if="pageNo !== 1" class="page-item">
                <a
                  class="page-link button"
                  href="javascript:;"
                  @click="showMyStake('home')"
                  >{{ $t("i18nView.index") }}</a
                >
              </li>
              <!-- <li v-if="previousPage" class="page-item">
                <a
                  class="page-link button"
                  href="javascript:;"
                  @click="showMyStake('previous')"
                >{{$t('i18nView.previousPage')}}</a>
              </li>-->
              <li v-if="!!nextPage" class="page-item">
                <a
                  class="page-link button"
                  href="javascript:;"
                  @click="showMyStake('next')"
                  >{{ $t("i18nView.nextPage") }}</a
                >
              </li>
            </ul>
          </div>
          <div v-else class="empty">{{ $t("i18nView.noStakeRecord") }}</div>
        </div>

        <!-- <div class="card">
          <h2>{{$t('i18nView.myRexHistory')}}</h2>
          <p v-for="record in myRexRecordList">{{record.timestamp | time}} {{record.amount}}</p>
        </div>-->
      </div>

      <div
        :class="
          tabName === 'res-tab'
            ? 'active col-4 resource-panel'
            : 'col-4 resource-panel'
        "
      >
        <div class="card">
          <h2>{{ $t("i18nView.resPrice") }}</h2>
          <!-- <div id="rent-chart"></div> -->
        </div>
        <div class="card res">
          <h2>
            {{ $t("i18nView.resBorrow") }}
            <em @click="openLoanStatus()">
              <b>{{ $t("i18nView.viewExpiredOrder") }}</b>
            </em>
          </h2>
          <p>{{ $t("i18nView.resTips") }}</p>
          <p>
            <label>REX {{ $t("i18nView.fund") }}:</label>
            {{ rexFundBalance }}
          </p>
          <p>
            <label>{{ $t("i18nView.currentPrice") }}:</label>
            {{ resPrice }} {{ sysSymbol }} * 30 {{ $t("i18nView.day") }} /
            {{ sysSymbol }}
          </p>

          <p>
            <label>{{ $t("i18nView.resType") }}：</label>

            <label class="res-type">
              <input type="radio" name="res" v-model="resType" value="cpu" />CPU
            </label>

            <label class="res-type">
              <input type="radio" name="res" v-model="resType" value="net" />NET
            </label>
          </p>

          <p>
            <label>{{ $t("i18nView.resReceiver") }}:</label>

            <input type="text" v-model="resReceiver" />
          </p>
          <p>
            <label>{{ $t("i18nView.payment") }}:</label>

            <input
              type="text"
              :placeholder="$t('i18nView.amount') + ' ' + sysSymbol"
              v-model="resPayment"
            />
            <br />
          </p>

          <p v-if="resPayment" class="input-tips">
            <label></label>
            <span
              >{{ $t("i18nView.willGet")
              }}{{ parseFloat(resPayment * resPrice).toFixed(4) }}
              {{ sysSymbol }} {{ resType.toUpperCase() }}(30D)</span
            >
          </p>

          <p>
            <label>{{ $t("i18nView.resourceFund") }}:</label>

            <input
              type="text"
              :placeholder="$t('i18nView.amount') + ' ' + sysSymbol"
              v-model="resFund"
            />
          </p>
          <p>
            <label></label>
            <button class="button success" @click="rentRes">
              {{ $t("i18nView.borrow") }}
            </button>
          </p>

          <p class="common-tips">{{ $t("i18nView.borrowInvilidTip") }}</p>

          <p class="common-tips">{{ $t("i18nView.resourceFundTips") }}</p>
        </div>

        <div class="card">
          <h2>{{ $t("i18nView.orders") }}</h2>
          <table style="min-width: 450px">
            <tr>
              <th>{{ $t("i18nView.resType") }}</th>
              <th>{{ $t("i18nView.stakedAccount") }}</th>
              <th>{{ $t("i18nView.amount") }}</th>
              <th>{{ $t("i18nView.dueTime") }}</th>
              <th>{{ $t("i18nView.payment") }}</th>
              <th>{{ $t("i18nView.resourceFund") }}</th>
              <th></th>
            </tr>
            <tr v-for="rent in rentList">
              <td>{{ rent.type }}</td>
              <td>{{ rent.receiver }}</td>
              <td>{{ rent.total_staked | number }}</td>
              <td>{{ rent.expiration | utcTime }}</td>
              <td>{{ rent.payment | number }}</td>
              <td>
                {{ rent.balance | number }}
                <br />
                <a @click="fund(rent)">
                  <i class="iconfont icon-add"></i>
                </a>
                <a @click="defund(rent)" v-if="parseFloat(rent.balance) > 0">
                  <i class="iconfont icon-minus"></i>
                </a>
              </td>
              <td></td>
            </tr>
          </table>
        </div>
      </div>

      <div class="col-2 mobile-only">
        <div class="card overview">
          <h2>{{ $t("i18nView.overview") }}</h2>
          <p>
            <label>{{ $t("i18nView.totalRex") }}:</label>
            {{ rexTotal }}
          </p>
          <p>
            <label>{{ sysSymbol }} {{ $t("i18nView.totalEos") }}:</label>
            {{ eosTotalLentable }}
          </p>
          <p>
            <label>{{ sysSymbol }} {{ $t("i18nView.lent") }}:</label>
            {{ eosTotalLent }}
          </p>
          <p>
            <label>{{ sysSymbol }} {{ $t("i18nView.lendable") }}:</label>
            {{ eosTotalUnlent }}
          </p>
          <p>
            <label>{{ $t("i18nView.totalRentNumber") }}:</label>
            {{ loanNum }}
          </p>
          <p>
            <label>{{ $t("i18nView.rentPrice") }}:</label>
            {{ resPrice }} {{ sysSymbol }} * 30 {{ $t("i18nView.day") }} /
            {{ sysSymbol }}
          </p>
          <p>
            <label>{{ $t("i18nView.lentPercent") }}:</label>
            {{
              parseFloat(
                (parseInt(eosTotalLent) / parseInt(eosTotalLentable)) * 100
              ).toFixed(2) + "%"
            }}
          </p>

          <!-- <p>
            <label>{{$t('i18nView.rentCost')}}:</label>
            {{parseFloat(parseFloat(eosTotalRent) - 20000).toFixed(4) + ' ' + sysSymbol}}
          </p>-->
          <p>
            <label for>{{ $t("i18nView.ramIncome") }}:</label>
            {{ ramIncome }}
          </p>
          <p>
            <label for>{{ $t("i18nView.bidnameIncome") }}:</label>
            {{ bidnameIncome }}
          </p>
          <p>
            <label>{{ $t("i18nView.apr") }}:</label>
            {{ apr }}
          </p>
        </div>
      </div>

      <div class="bottom">
        Copyright © 2019 Singapore
        <a target="_blank" href="https://www.tokenpocket.pro/?from=rex"
          >TokenPocket</a
        >
        Foundation Ltd. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
import Rex from "./rex";

export default {
  ...Rex,
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./rex.less" scope lang="less">
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue